import request from "./request";

export default function(defaultMimeType, response) {
  return function(url, callback) {
    var r = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/type.js
// module id = 46
// module chunks = 0